<template>
  <fn-notification-text
    :icon="data.icon"
    :icon-color="data.icon_color"
    :color="data.color"
    :background-color="data.background_color"
    :text="data.text"
  />
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
